/** Columns used to build the provider-card GraphQL query.
 * Defaults target the isidore-acc-v13 model.
 * The nested "services" selection is no longer listed here — it's built
 * dynamically in biobanksStore.ts from the serviceTableColumns config, so
 * that config controls both what's queried and what's displayed. */
export const initialBiobankReportColumns = [
  { label: "Juridical person:", column: "juridical_person" },
  /** properties that are required but should not be rendered as attributes */
  {
    column: ["id", "name", "withdrawn"],
  },
];

export default initialBiobankReportColumns;
